/**
 * UserRelationListReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * UserRelationListReq
 */
export interface UserRelationListReq {
  /** 搜索关键词 */
  q?: string
  /** 是否删除 */
  deleted?: boolean
  /** 页码 */
  page?: number
  /** 每页数量 */
  page_size?: number
  /** 排序字段 */
  order_by?: string
  /** 排序方向 */
  order?: string
  /** 创建时间范围 (start,end) */
  created_at__range?: any
  /** 更新时间范围 (start,end) */
  updated_at__range?: any
  /** 更新时间距今 (7d/1h/30m) */
  updated_at__since?: any
  /** 禁用状态 */
  disabled?: boolean
  /** ID列表 */
  id__in?: string[]
  /** 发起方用户ID */
  src_id?: any
  /** 目标方用户ID */
  dst_id?: any
  /** 是否关注 */
  is_following?: boolean
  /** 是否好友 */
  is_friend?: boolean
  /** 是否拉黑 */
  is_blocked?: boolean
  /** 是否屏蔽消息 */
  is_muted?: boolean
  /** 最小互动次数 */
  interaction_count__gte?: number
  /** 最大互动次数 */
  interaction_count__lte?: number
  /** 最小对战次数 */
  battle_count__gte?: number
  /** 最大对战次数 */
  battle_count__lte?: number
  /** 最小亲密度等级 */
  intimacy_level__gte?: number
  /** 最大亲密度等级 */
  intimacy_level__lte?: number
  /** 备注包含 */
  remark__like?: string
  /** 发起方用户ID列表 */
  src_id__in?: any
  /** 目标方用户ID列表 */
  dst_id__in?: any
  /** 关注时间距今 */
  followed_at__since?: any
  /** 关注时间早于 */
  followed_at__before?: any
  /** 成为好友时间距今 */
  friended_at__since?: any
  /** 成为好友时间早于 */
  friended_at__before?: any
  /** 最后互动时间距今 */
  last_interaction_at__since?: any
  /** 最后互动时间早于 */
  last_interaction_at__before?: any
}

/**
 * UserRelationListReq Schema
 */
export const UserRelationListReqSchema: SchemaDefinition = {
  properties: {
    q: {
      description: '搜索关键词',
      format: 'string',
      type: 'string',
      label: '搜索关键词',
    },
    deleted: {
      description: '是否删除',
      format: '*bool',
      type: 'boolean',
      label: '是否删除',
    },
    page: {
      description: '页码',
      format: 'int',
      type: 'integer',
      label: '页码',
    },
    page_size: {
      description: '每页数量',
      format: 'int',
      type: 'integer',
      label: '每页数量',
    },
    order_by: {
      description: '排序字段',
      format: 'string',
      type: 'string',
      label: '排序字段',
    },
    order: {
      description: '排序方向',
      format: 'string',
      type: 'string',
      label: '排序方向',
    },
    created_at__range: {
      description: '创建时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '创建时间范围',
    },
    updated_at__range: {
      description: '更新时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间范围',
    },
    updated_at__since: {
      description: '更新时间距今 (7d/1h/30m)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间距今',
    },
    disabled: {
      description: '禁用状态',
      format: '*bool',
      type: 'boolean',
      label: '禁用状态',
    },
    id__in: {
      description: 'ID列表',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: 'ID列表',
    },
    src_id: {
      description: '发起方用户ID',
      format: 'string',
      type: 'user',
      label: '发起方用户ID',
    },
    dst_id: {
      description: '目标方用户ID',
      format: 'string',
      type: 'user',
      label: '目标方用户ID',
    },
    is_following: {
      description: '是否关注',
      format: '*bool',
      type: 'boolean',
      label: '是否关注',
    },
    is_friend: {
      description: '是否好友',
      format: '*bool',
      type: 'boolean',
      label: '是否好友',
    },
    is_blocked: {
      description: '是否拉黑',
      format: '*bool',
      type: 'boolean',
      label: '是否拉黑',
    },
    is_muted: {
      description: '是否屏蔽消息',
      format: '*bool',
      type: 'boolean',
      label: '是否屏蔽消息',
    },
    interaction_count__gte: {
      description: '最小互动次数',
      format: '*int',
      type: 'integer',
      label: '最小互动次数',
    },
    interaction_count__lte: {
      description: '最大互动次数',
      format: '*int',
      type: 'integer',
      label: '最大互动次数',
    },
    battle_count__gte: {
      description: '最小对战次数',
      format: '*int',
      type: 'integer',
      label: '最小对战次数',
    },
    battle_count__lte: {
      description: '最大对战次数',
      format: '*int',
      type: 'integer',
      label: '最大对战次数',
    },
    intimacy_level__gte: {
      description: '最小亲密度等级',
      format: '*int',
      type: 'integer',
      label: '最小亲密度等级',
    },
    intimacy_level__lte: {
      description: '最大亲密度等级',
      format: '*int',
      type: 'integer',
      label: '最大亲密度等级',
    },
    remark__like: {
      description: '备注包含',
      format: 'string',
      type: 'string',
      label: '备注包含',
    },
    src_id__in: {
      description: '发起方用户ID列表',
      format: '[]string',
      type: 'user',
      label: '发起方用户ID列表',
    },
    dst_id__in: {
      description: '目标方用户ID列表',
      format: '[]string',
      type: 'user',
      label: '目标方用户ID列表',
    },
    followed_at__since: {
      description: '关注时间距今',
      format: '*string',
      type: 'datetime',
      label: '关注时间距今',
    },
    followed_at__before: {
      description: '关注时间早于',
      format: '*string',
      type: 'datetime',
      label: '关注时间早于',
    },
    friended_at__since: {
      description: '成为好友时间距今',
      format: '*string',
      type: 'datetime',
      label: '成为好友时间距今',
    },
    friended_at__before: {
      description: '成为好友时间早于',
      format: '*string',
      type: 'datetime',
      label: '成为好友时间早于',
    },
    last_interaction_at__since: {
      description: '最后互动时间距今',
      format: '*string',
      type: 'datetime',
      label: '最后互动时间距今',
    },
    last_interaction_at__before: {
      description: '最后互动时间早于',
      format: '*string',
      type: 'datetime',
      label: '最后互动时间早于',
    },
  },
  type: 'object',
}
